import SearchMobile from './SearchMobile';

export default SearchMobile;
